module.exports = __webpack_public_path__ + "static/img/feature-bg1.02f2b20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-2/feature-bg1.png
// module id = dcWM
// module chunks = 0